<div class="ks-container">
<header class="ks-page-header ks-rise-1">
  <div>
    <h2 class="ks-page-title">Panel de control</h2>
    <p class="ks-page-subtitle">
      Resumen de la operación de KeyStoreMan: cuentas, sesiones y catálogos de la bóveda.
    </p>
  </div>
</header>

<div class="dashboard__sections">
<div class="ks-grid ks-grid-4 dashboard__kpis">
  @for (kpi of kpis(); track kpi.key; let i = $index) {
    <a
      class="ks-kpi-card ks-card--interactive ks-kpi-card--{{ kpi.color }}"
      [routerLink]="kpi.route"
      [attr.aria-label]="kpiAriaLabel(kpi)"
      [class.ks-rise-1]="i === 0"
      [class.ks-rise-2]="i === 1"
      [class.ks-rise-3]="i === 2"
      [class.ks-rise-4]="i === 3">
      <div class="dashboard__kpi-top">
        <p class="ks-kpi-label">{{ kpi.label }}</p>
        <span class="dashboard__kpi-icon" aria-hidden="true"><i class="bi bi-{{ kpi.icon }}"></i></span>
      </div>

      @if (kpi.loading) {
        <div class="dashboard__kpi-skeleton">
          <app-skeleton width="72px" height="34px" [label]="'Cargando ' + kpi.label" />
        </div>
      } @else {
        <span class="ks-kpi-value">{{ kpi.value === null ? '—' : kpi.value }}</span>
      }

      <span class="ks-kpi-delta">
        @if (kpi.value === null && !kpi.loading) {
          <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
          <span>Sin datos disponibles</span>
        } @else {
          <span>{{ kpi.hint }}</span>
        }
      </span>
    </a>
  }
</div>

<section
  class="ks-panel dashboard__migration-panel ks-rise-5"
  aria-labelledby="migration-title">
  <div class="ks-card__header">
    <div>
      <h3 class="ks-card__title" id="migration-title">Migración a base de datos</h3>
      <p class="dashboard__panel-hint">
        Cuentas creadas con la versión anterior de la app (solo Firebase Auth) frente a las
        que ya están también en base de datos.
      </p>
    </div>
  </div>

  @if (migrationLoading()) {
    <div class="dashboard__migration-loading" role="status" aria-label="Cargando avance de migración">
      <app-skeleton shape="circle" width="110px" />
      <div class="ks-skeleton-stack dashboard__migration-loading-stats">
        <app-skeleton width="85%" height="14px" />
        <app-skeleton width="70%" height="14px" />
        <app-skeleton width="55%" height="14px" />
      </div>
    </div>
  } @else if (migrationSummary(); as migration) {
    <div class="dashboard__migration-body">
      <div
        class="dashboard__migration-ring-wrap"
        role="progressbar"
        [attr.aria-valuenow]="migrationPercentValue(migration)"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuetext]="migrationAriaLabel(migration)">
        <svg
          class="dashboard__migration-ring"
          viewBox="0 0 84 84"
          aria-hidden="true">
          <circle
            class="dashboard__migration-ring-track"
            cx="42"
            cy="42"
            [attr.r]="migrationRingRadius" />
          <circle
            class="dashboard__migration-ring-fill"
            cx="42"
            cy="42"
            [attr.r]="migrationRingRadius"
            [attr.stroke-dasharray]="migrationRingDashArray(migration)"
            stroke-dashoffset="0" />
        </svg>
        <div class="dashboard__migration-ring-center" aria-hidden="true">
          <span class="dashboard__migration-ring-percent ks-nums">
            {{ migrationPercentLabel(migration) }}
          </span>
          <span class="dashboard__migration-ring-caption">migrado</span>
        </div>
      </div>

      <dl class="dashboard__migration-stats">
        <div class="dashboard__migration-stat dashboard__migration-stat--done">
          <dt>
            <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
            En base de datos
          </dt>
          <dd class="ks-nums">{{ migration.registered }}</dd>
        </div>
        <div class="dashboard__migration-stat dashboard__migration-stat--pending">
          <dt>
            <i class="bi bi-hourglass-split" aria-hidden="true"></i>
            Pendientes (solo Firebase Auth)
          </dt>
          <dd class="ks-nums">{{ migration.unregistered }}</dd>
        </div>
        <div class="dashboard__migration-stat dashboard__migration-stat--total">
          <dt>Total de cuentas</dt>
          <dd class="ks-nums">{{ migration.total }}</dd>
        </div>
      </dl>
    </div>
  } @else {
    <app-empty-state
      icon="exclamation-triangle"
      title="Avance de migración no disponible"
      message="No se pudo calcular cuántas cuentas ya están en base de datos. Vuelve a intentarlo más tarde." />
  }
</section>

<section
  class="ks-panel dashboard__legal-panel ks-rise-6"
  aria-labelledby="legal-title">
  <div class="ks-card__header">
    <div>
      <h3 class="ks-card__title" id="legal-title">Aceptación legal</h3>
      <p class="dashboard__panel-hint">
        Cuentas registradas que ya aceptaron los Términos y condiciones y el Aviso de privacidad.
      </p>
    </div>
  </div>

  @if (migrationLoading()) {
    <div class="dashboard__migration-loading" role="status" aria-label="Cargando aceptación legal">
      <app-skeleton shape="circle" width="110px" />
      <div class="ks-skeleton-stack dashboard__migration-loading-stats">
        <app-skeleton width="85%" height="14px" />
        <app-skeleton width="70%" height="14px" />
        <app-skeleton width="55%" height="14px" />
      </div>
    </div>
  } @else if (legalSummary(); as legal) {
    <div class="dashboard__migration-body">
      <div
        class="dashboard__migration-ring-wrap"
        role="progressbar"
        [attr.aria-valuenow]="legalPercentValue(legal)"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuetext]="legalAriaLabel(legal)">
        <svg
          class="dashboard__migration-ring"
          viewBox="0 0 84 84"
          aria-hidden="true">
          <circle
            class="dashboard__migration-ring-track"
            cx="42"
            cy="42"
            [attr.r]="migrationRingRadius" />
          <circle
            class="dashboard__migration-ring-fill"
            cx="42"
            cy="42"
            [attr.r]="migrationRingRadius"
            [attr.stroke-dasharray]="legalRingDashArray(legal)"
            stroke-dashoffset="0" />
        </svg>
        <div class="dashboard__migration-ring-center" aria-hidden="true">
          <span class="dashboard__migration-ring-percent ks-nums">
            {{ legalPercentLabel(legal) }}
          </span>
          <span class="dashboard__migration-ring-caption">aceptó</span>
        </div>
      </div>

      <dl class="dashboard__migration-stats">
        <div class="dashboard__migration-stat dashboard__migration-stat--done">
          <dt>
            <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
            Aceptaron ambos
          </dt>
          <dd class="ks-nums">{{ legal.acceptedBoth }}</dd>
        </div>
        <div class="dashboard__migration-stat dashboard__migration-stat--pending">
          <dt>
            <i class="bi bi-hourglass-split" aria-hidden="true"></i>
            Con algo pendiente
          </dt>
          <dd class="ks-nums">{{ legal.registered - legal.acceptedBoth }}</dd>
        </div>
        <div class="dashboard__migration-stat dashboard__migration-stat--total">
          <dt>Cuentas registradas</dt>
          <dd class="ks-nums">{{ legal.registered }}</dd>
        </div>
      </dl>
    </div>
  } @else {
    <app-empty-state
      icon="exclamation-triangle"
      title="Aceptación legal no disponible"
      message="No se pudo calcular cuántas cuentas ya aceptaron los Términos y el Aviso de privacidad. Vuelve a intentarlo más tarde." />
  }
</section>

<section class="ks-panel dashboard__sessions ks-rise-7" aria-labelledby="recent-sessions-title">
  <div class="ks-card__header">
    <div>
      <h3 class="ks-card__title" id="recent-sessions-title">Últimas sesiones</h3>
      <p class="dashboard__panel-hint">Los {{ recentCount }} accesos más recientes.</p>
    </div>

    <a class="ks-btn ks-btn--glass ks-btn--sm" routerLink="/dashboard/sessions">
      <span>Ver todas</span>
      <i class="bi bi-arrow-right" aria-hidden="true"></i>
    </a>
  </div>

  <!-- Orden obligatorio: carga -> error -> vacio -> tabla. El estado vacio
       solo puede aparecer cuando ya se sabe con certeza que no hay datos. -->
  @if (loadingSessions()) {
    <div class="dashboard__rows" role="status" aria-label="Cargando las últimas sesiones">
      @for (row of skeletonRows; track row) {
        <app-skeleton height="42px" />
      }
    </div>
  } @else if (sessionsError()) {
    <app-empty-state
      icon="wifi-off"
      title="No se pudieron cargar las sesiones"
      [message]="sessionsError()!">
      <button type="button" class="ks-btn ks-btn--glass ks-btn--sm" (click)="retrySessions()">
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        Reintentar
      </button>
    </app-empty-state>
  } @else if (!hasSessions()) {
    <app-empty-state
      icon="laptop"
      title="Todavía no hay sesiones"
      message="Cuando alguien inicie sesión desde la app móvil, aparecerá aquí." />
  } @else {
    <div class="ks-table-wrap">
      <table class="ks-table ks-table--compact ks-table--sticky-first">
        <caption class="visually-hidden">Últimas sesiones registradas en KeyStoreMan</caption>
        <thead>
          <tr>
            <th scope="col">Dispositivo</th>
            <th scope="col">Usuario</th>
            <th scope="col">Ubicación</th>
            <th scope="col">Fecha</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>
        <tbody>
          @for (session of sessions(); track session.sessionId) {
            <tr>
              <td>
                <span class="dashboard__device">
                  <i class="bi bi-{{ platformIcon(session) }}" aria-hidden="true"></i>
                  <span class="ks-truncate">{{ deviceLabel(session) }}</span>
                </span>
              </td>
              <td class="ks-truncate">{{ userName(session.uidUser) }}</td>
              <td>{{ session.location || '—' }}</td>
              <td>{{ session.createdAt | dateToMoment }}</td>
              <td>
                @if (session.active) {
                  <span class="ks-badge ks-badge--success">Activa</span>
                } @else {
                  <span class="ks-badge ks-badge--muted">Cerrada</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</section>
</div>
</div>
